import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import FontAwesome from 'react-fontawesome'
import MenuIcon from './menu-icon.component'
import { Link, withRouter } from 'react-router-dom'
import { routes } from '../../constants/routes.constants'
import { UserService } from '../../services/user.service'
import StyledPrivateMenu from './styled-private-menu.style'
import { breakpoints } from '../../constants/breakpoints.constants'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { RoleConstants, MOVEFLEX_NUMBERS } from '../../constants'
import { userActions, clientActions } from '../../actions'
import { FORBIDDEN_TO_PUBLIC_BODY, LINKS_TITLE } from '@constants'
import {
	GiftPointsIcon,
	MyPurchasesIcon,
	PointsPurchaseIcon,
	ExtractOfPointsIcon,
	ClientInformationIcon,
	ExchangeYourPointsIcon,
	MuvicardIcon
} from '../../../assets/icons/menu/client'

const angleStyle = { marginLeft: '12px' }

const getTitle = role => {
	switch (role) {
		case RoleConstants.Admin:
			return LINKS_TITLE.ADMINISTRACAO_MUVIFLEX
		case RoleConstants.Client:
			return LINKS_TITLE.MINHA_CONTA
		case RoleConstants.Partner:
			return LINKS_TITLE.ADMINISTRACAO_PARCEIRO
		case RoleConstants.Financial:
			return LINKS_TITLE.FINANCEIRO
		default:
			break
	}
}

/**
 *
 * @param {array} items
 * Receives an array with the items to show on menu
 *
 * @param {string} role
 * Role of the user
 */
class PrivateMenuComponent extends Component {
	constructor(props) {
		super(props)

		this.props = props
		const isMobile = window.innerWidth <= breakpoints.MOBILE
		this.state = {
			isMobile
		}
		if (!isMobile) props.openPrivateMenu()
	}

	componentWillMount() {
		window.addEventListener('resize', this.handleWindowSizeChange)
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleWindowSizeChange)
	}

	handleWindowSizeChange = () => {
		const isMobile = window.innerWidth <= breakpoints.MOBILE
		if (this.state.isMobile && !isMobile) {
			const { openPrivateMenu } = this.props
			openPrivateMenu()
		}
		this.setState({ isMobile })
	}

	renderLinks = (item, index) => {
		const { location, closePrivateMenu, logout } = this.props
		const { isMobile } = this.state

		const isOpen = ({ to, links }) =>
			Array.isArray(links) ? links.some(isOpen) : to === location.pathname

		const opened = isOpen(item)
		const randomRef = 'item' + ~~(Math.random() * 999999)

		return item.to ? (
			item.insideApp ? (
				<Link
					className={`link${
						item.to === location.pathname ? ' active' : ''
					} ${item.text === 'Sair' ? 'sair' : ''}`}
					to={item.to}
					key={index}
					onClick={() => {
						if (isMobile) closePrivateMenu()
						if (item.text === 'Sair') logout()
					}}
					data-permission={item.dataPermission}>
					<MenuIcon title={item.text} isActive={opened} Icon={item.icon} />
					<span>{item.text}</span>
				</Link>
			) : (
				<a
					className={`link${
						item.to === location.pathname ? ' active' : ''
					}`}
					href={item.to}
					key={index}
					target="_blank"
					rel="noopener noreferrer"
					data-permission={item.dataPermission}>
					{item.text}
				</a>
			)
		) : (
			<li
				key={index}
				ref={randomRef}
				onClick={() => this.refs[randomRef].classList.toggle('is-open')}
				className={opened ? 'is-open' : ''}
				data-permission={item.dataPermission}>
				<MenuIcon title={item.text} isActive={opened} Icon={item.icon} />
				<span>{item.text}</span>
				<FontAwesome style={angleStyle} name="angle-right" />
				<ul>{item.links.map(this.renderLinks)}</ul>
			</li>
		)
	}

	openPrivateMenu = () => {
		const { openPrivateMenu, closeMobileMenu } = this.props
		closeMobileMenu()
		openPrivateMenu()
	}

	isClient = () => this.props.role && this.props.role === RoleConstants.Client
	isAdmin = () => this.props.role && this.props.role === RoleConstants.Admin
	isPartner = () =>
		this.props.role && this.props.role === RoleConstants.Partner

	getItems = () => {
		const { role, plan, moveflexNumber } = this.props

		let links = []

		switch (role) {
			case RoleConstants.Admin:
				links.push(
					{
						text: LINKS_TITLE.CRIAR_PONTOS,
						to: `${routes.ADMIN}/criar-pontos`,
						insideApp: true,
						dataPermission: 'E997D27A3312D5439C84EC06F4F11077BAEFE7CD'
					},
					{
						text: LINKS_TITLE.MOVIMENTAR_PONTOS,
						to: `${routes.ADMIN}/movimentar-pontos`,
						insideApp: true,
						dataPermission: 'AB8EACBB1D55F44E2C75EBB19018F3F1A29E9F91'
					},
					{
						text: LINKS_TITLE.CLIENTES,
						to: `${routes.ADMIN}/clientes`,
						insideApp: true,
						dataPermission: 'E84B64F4B7A2A17134CB7DB3BB71ED68A6750D68'
					},
					{
						text: LINKS_TITLE.FUNCIONARIOS,
						to: `${routes.ADMIN}/funcionarios`,
						insideApp: true,
						dataPermission: '9C62938C82C90A4FC13684B1D106E20FDCEF823A'
					},
					{
						text: LINKS_TITLE.CUPONS_DE_DESCONTO,
						to: `${routes.ADMIN}/cupons-de-desconto`,
						insideApp: true,
						dataPermission: 'A56A2313956DA360048F70C79A0EC824A878851C'
					},
					{
						text: LINKS_TITLE.LOJA_MUVIFLEX,
						to: `${routes.ADMIN}/loja-moveflex`,
						insideApp: true,
						dataPermission: 'FB8FE6CBAAC264D568EB3FD4288A95BD8317DA1E'
					},
					{
						text: LINKS_TITLE.RELATORIOS,
						dataPermission: 'C17ACB3FFB93F75D510DEED7BEB8C503B3A7BA87',
						links: [
							{
								text: LINKS_TITLE.CLIENTES,
								to: `${routes.ADMIN}/relatorios/clientes`,
								insideApp: true,
								dataPermission:
									'B3F2B1C52B4CBE4573DE0500CF86D16D115816DF'
							},
							{
								text: LINKS_TITLE.EXTRATO_DE_PONTOS,
								to: `${routes.ADMIN}/relatorios/extrato-de-pontos`,
								insideApp: true,
								dataPermission:
									'2699E537BD28E36D6264BB19B7D1B9FEF10B5490'
							},
							{
								text: LINKS_TITLE.BREAKAGE_DE_PONTOS,
								to: `${routes.ADMIN}/relatorios/breakage`,
								insideApp: true,
								dataPermission:
									'D8C55A4BB887BBF36B74527C06D89AA7136FBA7A'
							},
							{
								text: LINKS_TITLE.VENDAS_FATURAMENTO,
								to: `${routes.ADMIN}/relatorios/vendas-faturamento`,
								insideApp: true,
								dataPermission:
									'8484DE0E4A73EBAF1DA34274A81F40740DB69187'
							},
							{
								text: LINKS_TITLE.CLUBE_MUVIFLEX,
								to: `${routes.ADMIN}/relatorios/clube-moveflex`,
								insideApp: true,
								dataPermission:
									'DE5B16071FE4ADFBC70FC6D782CF7144AF74F84C'
							},
							{
								text: LINKS_TITLE.PASSAGENS_VENDIDAS,
								to: `${routes.ADMIN}/passagens-vendidas`,
								insideApp: true,
								dataPermission:
									'C0652F3F1B20C41180229229A2ED44FE50E1861D'
							},
							{
								text: LINKS_TITLE.SOLICITACOES_DE_CARTAO,
								to: `${routes.ADMIN}/relatorios/solicitacoes-cartao`,
								insideApp: true,
								dataPermission:
									'B345F4E6473E13F4897BD8AEB37AAB542CD47B32'
							},
							{
								text: LINKS_TITLE.FATURAS,
								to: `${routes.ADMIN}/relatorios/faturas`,
								insideApp: true,
								dataPermission:
									'DE8F8CB29767FCC89C302F0A7E6196ACC6EB8E17'
							}
						]
					}
				)
				break

			case RoleConstants.Client:
				links.push(
					{
						text: LINKS_TITLE.CARTAO_MUVICARD,
						to: `${routes.MEU_CARTAO}`,
						insideApp: true,
						icon: MuvicardIcon
					},
					// {
					// 	text: LINKS_TITLE.COMPRE_E_GANHE,
					// 	to: `${routes.CLIENTE}/compre-e-ganhe`,
					// 	insideApp: true,
					// 	icon: PointsSolicitationIcon
					// },
					{
						text: LINKS_TITLE.LOJA,
						to: `${routes.LOJA}`,
						insideApp: true,
						icon: ExchangeYourPointsIcon
					},
					{
						text: LINKS_TITLE.COMPRA_DE_PONTOS,
						to: `${routes.CLIENTE}/compra-de-pontos`,
						insideApp: true,
						icon: PointsPurchaseIcon
					}
				)

				// plan
				// 	? links.push({
				// 		text: LINKS_TITLE.CLUBE_MUVIFLEX,
				// 		links: [
				// 			{
				// 				text: LINKS_TITLE.MEU_PLANO,
				// 				to: `${routes.CLIENTE}/meu-plano`,
				// 				insideApp: true
				// 			},
				// 			{
				// 				text: LINKS_TITLE.HISTORICO,
				// 				to: `${routes.CLIENTE}/historico-de-pagamentos`,
				// 				insideApp: true
				// 			}
				// 		],
				// 		icon: MoveflexClubIcon
				// 	})
				// 	: links.push({
				// 		text: LINKS_TITLE.CLUBE_MUVIFLEX,
				// 		to: `${routes.CLIENTE}/planos`,
				// 		insideApp: true,
				// 		icon: MoveflexClubIcon
				// 	})

				links.push(
					{
						text: LINKS_TITLE.PONTOS_DE_PRESENTE,
						to: `${routes.CLIENTE}/compra-de-pontos-presente`,
						insideApp: true,
						icon: GiftPointsIcon
					},
					// {
					// 	text: LINKS_TITLE.CONVIDE_SEUS_AMIGOS,
					// 	to: `${routes.CLIENTE}/convide-seus-amigos`,
					// 	insideApp: true,
					// 	icon: InviteYourFriendsIcon
					// },
					{
						text: LINKS_TITLE.EXTRATO_DE_PONTOS,
						to: `${routes.CLIENTE}/extrato`,
						insideApp: true,
						icon: ExtractOfPointsIcon
					},
					{
						text: LINKS_TITLE.MINHAS_COMPRAS,
						to: `${routes.CLIENTE}/minhas-compras`,
						insideApp: true,
						icon: MyPurchasesIcon
					},
					// {
					// 	text: LINKS_TITLE.SOLICITACAO_DE_PONTOS,
					// 	to: `${routes.CLIENTE}/solicitacao-de-pontos`,
					// 	insideApp: true,
					// 	icon: PointsSolicitationIcon
					// },
					{
						text: LINKS_TITLE.MEUS_DADOS,
						to: `${routes.CLIENTE}/meus-dados`,
						insideApp: true,
						icon: ClientInformationIcon
					}
				)

				break

			case RoleConstants.Partner:
				links.push({
					text: LINKS_TITLE.EXTRATO_DE_PONTOS,
					to: `${routes.PARCEIRO}/extrato-de-pontos`,
					insideApp: true
				})

				if (
					moveflexNumber === MOVEFLEX_NUMBERS.PLANALTO ||
					moveflexNumber === MOVEFLEX_NUMBERS.UNESUL ||
					moveflexNumber === MOVEFLEX_NUMBERS.ROTA
				) {
					links.push({
						text: LINKS_TITLE.PASSAGENS_VENDIDAS,
						to: `${routes.PARCEIRO}/passagens-vendidas`,
						insideApp: true
					})
				}

				break

			default:
				links.push(
					{ text: 'Link direto', to: '/', insideApp: true },
					{
						text: 'Menu com sub-links',
						links: [
							{ text: 'Link 1', to: '/', insideApp: true },
							{ text: 'Link 2', to: '/', insideApp: true }
						]
					}
				)

				break
		}

		links.push({ text: 'Sair', to: '/', insideApp: true })
		return links
	}

	render() {
		const {
			name,
			role,
			balancePoints,
			expiringPoints,
			moveflexNumber,
			moveflexPoints,
			closePrivateMenu,
			privateMenuState,
			getPointsInformation,
			clientPointsWasLoaded,
			moveflexPointsWasLoaded
		} = this.props

		const ErrorFetchPoints = () => (
			<div className="white bold points">
				Houve algum erro ao buscar os pontos
				<div
					className="danger"
					onClick={getPointsInformation}
					style={{ cursor: 'pointer' }}>
					<FontAwesome name="refresh" style={{ marginRight: '10px' }} />
					Tentar novamente
				</div>
			</div>
		)

		return (
			<StyledPrivateMenu
				className={`private-menu ${
					privateMenuState ? 'is-open' : 'is-close'
				}`}>
				<div className="title">
					<span className="text">{getTitle(role)}</span>
					<FontAwesome
						className="open-close-btn"
						name={`${privateMenuState ? 'arrow-left' : 'bars'}`}
						onClick={() =>
							privateMenuState
								? closePrivateMenu()
								: this.openPrivateMenu()
						}
					/>
				</div>
				<div className="user-info">
					<div className="white bold name">
						Olá {UserService.getFirstName(name)}!
						{this.isClient() && (
							<div className="white">Nº Muviflex: {moveflexNumber}</div>
						)}
					</div>
					{this.isClient() &&
						(clientPointsWasLoaded ? (
							balancePoints !== null && expiringPoints !== null ? (
								<div className="white bold points">
									{Number(balancePoints).toLocaleString('pt-BR')}{' '}
									pontos
									{/* <div className="white">
										Expira em 30 dias:{' '}
										{Number(expiringPoints).toLocaleString('pt-BR')}{' '}
										pontos
									</div> */}
								</div>
							) : (
								<ErrorFetchPoints />
							)
						) : (
							<div className="white bold points">
								Carregando pontos...
							</div>
						))}

					{this.isAdmin() &&
						(moveflexPointsWasLoaded ? (
							moveflexPoints !== null ? (
								<div className="white bold points">
									{Number(moveflexPoints).toLocaleString('pt-BR')}{' '}
									pontos
									<div className="white">
										Disponíveis na conta Muviflex
									</div>
								</div>
							) : (
								<ErrorFetchPoints />
							)
						) : (
							<div className="white bold points">
								Carregando pontos...
							</div>
						))}
				</div>
				<ul className="links">
					{this.getItems().map((item, idx) => {
						let linksList = FORBIDDEN_TO_PUBLIC_BODY

						if (
							this.props.hasPublicBody &&
							linksList.find(link => link == item.text)
						) {
							return null
						}

						return this.renderLinks(item, idx)
					})}
				</ul>
			</StyledPrivateMenu>
		)
	}
}

PrivateMenuComponent.propTypes = {
	role: PropTypes.string.isRequired
}

const mapStateToProps = ({ site, user, client, partner, admin }) => ({
	mobileMenuState: site.mobileMenuState,
	privateMenuState: site.privateMenuState,
	...user,
	...client,
	...partner,
	...admin
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			logout: userActions.logout,
			openPrivateMenu: SiteCreators.openPrivateMenu,
			closeMobileMenu: SiteCreators.closeMobileMenu,
			closePrivateMenu: SiteCreators.closePrivateMenu,
			getPointsInformation: clientActions.getPointsInformation
		},
		dispatch
	)

const PrivateMenu = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PrivateMenuComponent)
)

export default PrivateMenu
